import React from 'react';
import Button from '@mui/material/Button';

export const csvDownloadFunction = async (functionUrl, functionParams) => {
  try {
    const PARAMS = functionParams;
    const URL = functionUrl;

    const searchParams = new URLSearchParams(PARAMS);

    const token = JSON.parse(localStorage.getItem('cred'))?.token;

    if (!token) {
      console.error('No authentication token found');
      return;
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}users/download-token`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to get download token');
    }

    const data = await response.json();

    const downloadToken = data?.data?.downloadToken || data?.downloadToken;

    if (downloadToken) {
      searchParams.append('downloadToken', downloadToken);
    } else {
      console.warn('No downloadToken returned from server. Download might fail.');
    }

    const finalUrl = `${process.env.REACT_APP_API_URL}${URL}${Object.keys(PARAMS).length ? '?' : '&'}${searchParams.toString()}`;

    window.location.href = finalUrl;
  } catch (e) {
    console.log('Error triggering download:', e);
  }
};

const ProgressionDownloadButton = ({
  url,
  params,
  buttonName = 'Download',
  fullWidth = false,
  buttonIcon = null,
  sx = {},
  disabled = false,
}) => {
  return (
    <Button
      sx={sx}
      variant="contained"
      onClick={() => csvDownloadFunction(url, params)}
      fullWidth={fullWidth}
      startIcon={buttonIcon}
      disabled={disabled}
    >
      {buttonName}
    </Button>
  );
};

export default React.memo(ProgressionDownloadButton);

// import React from 'react';
// import Button from '@mui/material/Button';

// const ProgressionDownloadButton = ({
//   URL,
//   params,
//   buttonName = 'Download',
//   fullWidth = false,
//   buttonIcon = null,
//   sx = {},
// }) => {

//   const handleDownload = () => {
//     try {
//       // 1. Build the dynamic Query Params containing user filters
//       const searchParams = new URLSearchParams(params);

//       // 2. Attach the secure authorization Token directly into the URL!
//       const token = JSON.parse(localStorage.getItem('cred'))?.token;
//       if (token) {
//         searchParams.append('token', token);
//       }

//       // 3. Construct the full backend API
//       const finalUrl = `${process.env.REACT_APP_API_URL}${URL}?${searchParams.toString()}`;

//       // 4. Trigger the incredibly fast Native Browser Download!
//       // This immediately pops open the Browser's standard downloading UI
//       window.location.href = finalUrl;

//     } catch (e) {
//       console.log("Error triggering download:", e);
//     }
//   };

//   return (
//     <Button
//       sx={sx}
//       variant="contained"
//       onClick={handleDownload}
//       fullWidth={fullWidth}
//       startIcon={buttonIcon}
//     >
//       {buttonName}
//     </Button>
//   );
// };

// export default React.memo(ProgressionDownloadButton);

// // import React, { useEffect, useState } from 'react';
// // import Button from '@mui/material/Button';

// // const ProgressionDownloadButton = ({
// //   URL,
// //   params,
// //   buttonName = 'Download',
// //   loadingButtonName = 'Downloading...',
// //   fullWidth = false,
// //   buttonIcon = null,
// //   sx = {},
// //   downloadFilName = 'interval',
// //   downloadType = '',
// // }) => {
// //   const [downloading, setDownloading] = useState(false);
// //   const [bytesReceived, setBytesReceived] = useState(0);
// //   const [totalBytes, setTotalBytes] = useState(0);

// //   const handleDownload = async () => {
// //     setDownloading(true);
// //     setBytesReceived(0);
// //     setTotalBytes(0);

// //     const searchParams = new URLSearchParams(params);

// //     try {
// //       const response = await fetch(`${process.env.REACT_APP_API_URL}${URL}?${searchParams}`, {
// //         method: 'GET',
// //         headers: {
// //           Authorization: `Bearer ${JSON.parse(localStorage.getItem('cred'))?.token}`,
// //         },
// //       });
// //       const reader = response.body.getReader();
// //       const chunks = [];
// //       let receivedBytes = 0;
// //       const totalSize = response.headers.get('content-length');
// //       while (true) {
// //         const { done, value } = await reader.read();

// //         if (done) {
// //           break;
// //         }

// //         chunks.push(value);

// //         receivedBytes += value.length;
// //         setBytesReceived((receivedBytes / 1024).toFixed(2));
// //         setTotalBytes((totalSize / 1024).toFixed(2));
// //       }

// //       const blob = new Blob(chunks, { type: downloadType });
// //       const url = window.URL.createObjectURL(blob);

// //       const link = document.createElement('a');
// //       link.href = url;
// //       link.download = `${downloadFilName}.${downloadType.split('/')?.[1]}`;
// //       document.body.appendChild(link);
// //       link.click();

// //       window.URL.revokeObjectURL(url);
// //       document.body.removeChild(link);
// //     } catch (e) {
// //       console.log({ error: e });
// //     }

// //     setDownloading(false);
// //   };

// //   const progress = totalBytes ? (bytesReceived / totalBytes) * 100 : 0;

// //   useEffect(() => {
// //     if (!downloading) {
// //       setBytesReceived(0);
// //       setTotalBytes(0);
// //     }
// //   }, [downloading]);

// //   return (
// //     <Button
// //       sx={{
// //         ...sx,
// //         ...(downloading ? { background: `linear-gradient(to right, #4caf50 ${progress}%, #e0e0e0 ${progress}%)` } : {}),
// //         ' &.Mui-disabled': {
// //           ...(downloading && Boolean(progress) ? { color: 'black' } : { color: `rgba(0, 0, 0, 0.26)` }),
// //         },
// //       }}
// //       variant="contained"
// //       onClick={handleDownload}
// //       disabled={downloading}
// //       fullWidth={fullWidth}
// //       startIcon={downloading ? null : buttonIcon}
// //     >
// //       {downloading ? (progress ? `${progress.toFixed(2)}%` : loadingButtonName) : buttonName}
// //     </Button>
// //   );
// // };

// // export default React.memo(ProgressionDownloadButton);
